module.exports = __webpack_public_path__ + "img/woman-ad-bg.d69b5e79.svg";